// API Configuration constants
export const API_KEY = 'a1e72fd93ed59f56e6332813b9f8dcae';
export const BASE_URL = 'https://api.themoviedb.org/3';
export const CUSTOM_API_URL = 'https://api-blond-ten.vercel.app/api/scraper/netflix/tv';
export const CACHE_KEY_TOP10 = 'netflixTop10PH';

export const TRAKT_API_KEY = 'c3e07f0e12ed8805d642ab44a87e67417a8dc71e738079718b6aa3e49ae5505c'; // Replace with your Trakt Client ID
export const TRAKT_BASE_URL = 'https://api.trakt.tv';